import clsx from 'clsx';
import React from 'react';
import WarningIcon from '../../assets/icons/warning-icon.svg?react';
import TextArea from '../TextArea';
import Button from '../Button';
import { useButtonSizeSmall } from '../../utils/buttonSizes';
import { ManualSubscriptionStatusEnum, Organization } from '@EHSNavigator/backend';

interface RejectOrganizationModalProps {
    otherClasses?: string;
    formHandler: any;
    onClose: () => void;
    organization?: Organization;
}

const RejectOrganizationModal: React.FC<RejectOrganizationModalProps> = ({
    otherClasses,
    formHandler,
    onClose,
    organization,
}) => {
    const rejectOrganizationModalClasses = clsx(otherClasses);
    const isReqExtension = organization?.manualSubscription?.status === ManualSubscriptionStatusEnum.RequestExtension;

    return (
        <div
            className={rejectOrganizationModalClasses}
            data-testid="reject-organization-modal"
        >
            <div className="mb-6 flex w-full flex-col items-center gap-2.5 text-center lg:mb-9">
                <WarningIcon className="[&>path]:fill-brand-papery h-12 w-12 md:h-85 md:w-85" />
                <h4 className="text-brand-posh-pink">
                    {
                        isReqExtension ? 'Reject Extension Cause?' : 'Rejection Cause?'
                    }
                </h4>
                <p className="font-inter-variable text-lg leading-5 font-normal text-brand-posh-pink">
                    {
                        isReqExtension ?
                            <>Write the reason below for rejecting the extension requested by <span className="font-bold text-white capitalize">{organization?.name}</span>.</> :
                            `Write the reason below for rejecting the organization access request.`
                    }
                </p>
            </div>
            <form action="#" onSubmit={formHandler?.handleSubmit}>
                <div className="mt-2.5 grid grid-cols-1">
                    <TextArea
                        name="description"
                        onBlur={formHandler?.handleBlur}
                        onChange={formHandler?.handleChange}
                        value={formHandler?.values?.description}
                        placeholder="Write something here e.g. The organization does not meet our requirements..."
                        disabled={formHandler?.isSubmitting}
                        errorMessage={
                            formHandler?.touched.description &&
                                formHandler?.errors.description
                                ? formHandler?.errors.description
                                : ''
                        }
                        label="Reason*"
                        otherClasses={{ container: 'w-full ' }}
                    />
                </div>
                <div className="mt-6 flex flex-col-reverse gap-15 md:grid md:grid-cols-2 md:gap-6 lg:mt-12">
                    <Button
                        variant="secondary"
                        type="button"
                        size={useButtonSizeSmall()}
                        onClick={onClose}
                        disable={formHandler?.isSubmitting}
                        otherClasses="text-brand-posh-pink hover:border-brand-posh-pink hover:text-brand-posh-pink"
                    >
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        size={useButtonSizeSmall()}
                        loading={formHandler?.isSubmitting}
                        disable={formHandler?.isSubmitting}
                        otherClasses="bg-brand-posh-pink hover:text-brand-posh-pink hover:border-brand-posh-pink"
                    >
                        Reject
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default RejectOrganizationModal;

